import ReservationQuestionnaire from './ReservationQuestionnaire';

export default ReservationQuestionnaire;
